var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"8":1,"89":1,"131":1,"135":1,"155":1,"314":1,"501":1,"758":1,"891":1,"1184":1,"1240":1,"1254":1,"1278":1,"1289":1,"1301":1,"1361":1,"1453":1,"1510":1,"1534":1,"1785":1,"1817":1,"1833":1,"1898":1,"2043":1,"2046":1,"2161":1,"2380":1,"2567":1,"2573":1,"2587":1,"2727":1,"3083":1,"3182":1,"3505":1,"3577":1,"3790":1,"3910":1,"3992":1,"4503":1,"4557":1,"4587":1,"4620":1,"4703":1,"4734":1,"4840":1,"4873":1,"4906":1,"5212":1,"5404":1,"5471":1,"5472":1,"5486":1,"5593":1,"5631":1,"5723":1,"5728":1,"5885":1,"6121":1,"6135":1,"6243":1,"6465":1,"6544":1,"6565":1,"6786":1,"6865":1,"7192":1,"7219":1,"7221":1,"7256":1,"7376":1,"7701":1,"7748":1,"7771":1,"7842":1,"8210":1,"8259":1,"8331":1,"8376":1,"8445":1,"8569":1,"8573":1,"8648":1,"8861":1,"8969":1,"9013":1,"9138":1,"9318":1,"9323":1,"9450":1,"9501":1,"9748":1,"9788":1,"9930":1,"9996":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr